<template>
  <div>
    <div class="cover cover--small" :style="'background-image: url(' + require('@/assets/cover-vote.jpg') + ')'">
        <h1 class="cover__title">Vote</h1>
    </div>

    <template v-if="added">
        <div class="wrapper wrapper--spaced wrapper--centered white-box">
            <h1 class="title title--spaced">Thank you!</h1>
            <p class="text">Thank you for joining this movement! We will be in touch.</p>
        </div>
    </template>

    <template v-else>
        <div class="wrapper wrapper--spaced wrapper--centered white-box">
            <h1 class="title title--spaced">Step 1: Register to vote</h1>
            <form class="form" method="post" action="/webservices/forms.php">
                <div class="form__item form__item--duo"><label>First Name</label><input name="firstname" type="text" autocomplete="given-name" required/></div>
                <div class="form__item form__item--duo"><label>Last Name</label><input name="lastname" type="text" autocomplete="family-name" required/></div>
                <div class="form__item"><label>Email*</label><input name="email" type="email" autocomplete="email" required/></div>
                <div class="form__item"><label>Address*</label><input name="address" type="text" autocomplete="address-line1" placeholder="123 Main St" required/></div>
                <div class="form__item form__item--duo"><label>B.C. Postal Code*</label><input name="zip" type="text" autocomplete="postal-code" placeholder="V8V 1X4" pattern="[vV][0-9][A-Za-z][\s]?[0-9][A-Za-z][0-9]" required/></div>
                <div class="form__item form__item--duo"><label>Phone*</label><input name="phone" type="tel" autocomplete="tel" placeholder="123-456-7890" pattern="[1]?[-\s]?[(]?\d{3}[)\s]?[-\s]?\d{3}[-\s]?\d{4}"/></div>
                <div class="form__item"><label class="option"><input type="checkbox" name="resident" value="yes" required>I confirm I am a resident of B.C. and a Canadian citizen (or permanent resident)</label></div> 
                <div class="form__item"><label class="option"><input type="checkbox" name="contribution_interest" value="yes"/> I’m interested in learning more about contributing financially</label></div>
                <div class="form__item"><label class="option"><input type="checkbox" name="volunteer" value="yes"/> I’m interested in learning more about becoming a volunteer</label></div>
                <input type="hidden" name="source" value="vote"/>
                <input type="submit" value="Register" class="button button--red" style="margin-top: 30px"/>
            </form>
        </div>
    </template>
  </div>
</template>

<script>
export default {

    mounted() {
        this.handleChange();
        this.changeContributionType();
    },
    data() {
        return {
            periodicity: 'one'
        }
    },
    computed: {
        added () {
            return this.$router.currentRoute.query.hasOwnProperty('added');
        }
    },
    methods: {
        handleChange(event) {
            if(document.getElementById("other").checked || (event && event.target.value == 'other')) {
                document.getElementById('other_amount').style.display = '';
                document.querySelector("input[name=other_amount]").required = true;
                document.querySelector("input[name=other_amount]").pattern = "\\d+(\\.\\d{2})?";
            }
            else {
                document.getElementById('other_amount').style.display = 'none';
                document.querySelector("input[name=other_amount]").removeAttribute("pattern"); 
            }
        },

        changePeriodicity(event) {
            this.periodicity = event.target.value;
        },
    }

}
</script>

<style scoped>

</style>
